import {Injectable, Inject} from 'ng-metadata/core';
import {TemplateUtil} from '../../nddUtils/templateUtil.service';
import {getVid} from '../../appConfig/appConfigForward';
const flatten = require('lodash/flatten');

@Injectable()
export class PushtoService {
    private PUSHTO_API_URL: string;
    private vid:string = getVid();

    constructor(private templateUtil: TemplateUtil,
                @Inject('$http') private $http: ng.IHttpService,
                @Inject('restBaseURLs') private restBaseURLs) {
        this.PUSHTO_API_URL= restBaseURLs.actionsBaseURL+'/pushto/';
    }

    public getServiceUrl(items, selectedIds, target,additionalParams?: Object) {
        //TODO: call rest api to get the service url
        let payload = this.buildPayload(flatten(items),selectedIds,additionalParams);
        console.log("payload push to");
        console.log(payload);
        return this.$http.post(this.PUSHTO_API_URL + target+"?vid="+this.vid, payload);
    }
    
    private buildPayload(items: Object, selectedIds: any ,additionalParams?:Object) {
        let json = {"records":selectedIds ? selectedIds: items
                    };
        for(let key in additionalParams){
            json[key] = additionalParams[key];
        };
        return json;
    }


    
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/pushto.service.ts